<template>
  <v-container>
    <v-row class="text-center">
      <v-col offset="2" cols="8">
        <v-card class="pa-5" elevation="0">
          <img src="https://www.leeb.at/app/uploads/2020/05/leeb-logo.svg" height="128px" width="256px"/>
          <p class="mt-5 mb-10">Willkommen im <b>MyLeeb-Portal!</b></p>
          <v-btn
            color="primary"
            elevation="2"
            @click="$router.push({path: '/login'})"
            class="mb-5"
          >Direkt zur Anmeldung!</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home'
}
</script>
